import $api from "../api/config";
import type { AxiosResponse } from "axios";
import type { TechnicalTaskResponse, TechnicalTaskError } from "../types/technical-task";

export type { TechnicalTaskResponse, TechnicalTaskError };

export const getTechnicalTaskText = (
  telegramUserId: string
): Promise<AxiosResponse<TechnicalTaskResponse | TechnicalTaskError>> => {
  return $api.get(`/technical-tasks/${telegramUserId}/text/`);
};
